import axios from "axios";

export const fetchReadingThresholds = async (readingTypeId) => {
    const response = await axios.get(`api/readingthresholds/${readingTypeId}`);
    const readingThresholds = response.data;
    return readingThresholds;
}

export const fetchReadingAllThresholdsForMachine = async (machineId) => {
    const response = await axios.get(`api/readingthresholds/machine/${machineId}`);
    const readingThresholds = response.data;
    return readingThresholds;
}

export const updateReadingThreshold = async (readingThreshold) => {
    try {
        const response = await axios.put(`api/readingthresholds/`, readingThreshold);
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
}